var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.visible,
        title: "查看合同",
        width: "660px",
        "before-close": _vm.handleClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "contractFormRef",
          attrs: {
            model: _vm.contractForm,
            "label-width": "80px",
            disabled: true,
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "合同名称", prop: "contractName" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入合同名称" },
                model: {
                  value: _vm.contractForm.contractName,
                  callback: function ($$v) {
                    _vm.$set(_vm.contractForm, "contractName", $$v)
                  },
                  expression: "contractForm.contractName",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "合同编码", prop: "contractCode" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入合同编码" },
                model: {
                  value: _vm.contractForm.contractCode,
                  callback: function ($$v) {
                    _vm.$set(_vm.contractForm, "contractCode", $$v)
                  },
                  expression: "contractForm.contractCode",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "签署方一", prop: "draftShopName" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请选择签署方" },
                model: {
                  value: _vm.contractForm.draftShopName,
                  callback: function ($$v) {
                    _vm.$set(_vm.contractForm, "draftShopName", $$v)
                  },
                  expression: "contractForm.draftShopName",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "签署方二", prop: "coopShopId" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请选择签署方" },
                model: {
                  value: _vm.contractForm.coopShopName,
                  callback: function ($$v) {
                    _vm.$set(_vm.contractForm, "coopShopName", $$v)
                  },
                  expression: "contractForm.coopShopName",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "upload-container" }, [
        _c(
          "div",
          { staticClass: "value input fill" },
          [
            _c("ossFileUpload", {
              ref: "refPicFileUpload",
              staticStyle: { "margin-bottom": "10px" },
              attrs: {
                limit: _vm.maxFileCount,
                accept: _vm.picFileExt,
                maxFileLength: 10,
                ossUpload: true,
                ossPathDir: "shop/pic/",
                disabled: _vm.isDisabled,
                onPreview: _vm.handlePreview,
              },
              model: {
                value: _vm.picFileList,
                callback: function ($$v) {
                  _vm.picFileList = $$v
                },
                expression: "picFileList",
              },
            }),
            !_vm.isDisabled
              ? _c("div", { staticClass: "small-tip warning" }, [
                  _c("span", [
                    _vm._v(
                      "最多支持" +
                        _vm._s(_vm.maxFileCount) +
                        "张，单张不超过10M； 支持" +
                        _vm._s(_vm.picFileExt)
                    ),
                  ]),
                ])
              : _vm._e(),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "audit-section" },
        [
          _c(
            "el-form",
            { ref: "formRef", attrs: { model: _vm.form, rules: _vm.rules } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "审核结果", prop: "auditResult" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { disabled: _vm.checkDisable },
                      on: { change: _vm.handleAuditChange },
                      model: {
                        value: _vm.form.auditResult,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "auditResult", $$v)
                        },
                        expression: "form.auditResult",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("通过")]),
                      _c("el-radio", { attrs: { label: 2 } }, [_vm._v("驳回")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.form.auditResult === 2
                ? _c(
                    "el-form-item",
                    { attrs: { label: "驳回理由", prop: "rejectReason" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          placeholder: "请输入驳回理由",
                          disabled: _vm.checkDisable,
                        },
                        model: {
                          value: _vm.form.rejectReason,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "rejectReason", $$v)
                          },
                          expression: "form.rejectReason",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.handleClose } }, [_vm._v("取消")]),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.checkDisable,
                  expression: "!checkDisable",
                },
              ],
              attrs: { type: "primary", loading: _vm.uploading },
              on: { click: _vm.submitUpload },
            },
            [_vm._v(" 提交 ")]
          ),
        ],
        1
      ),
      _c("FileViewer", { ref: "fileViewerRef" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }